import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[appDisabled]',
  standalone: true,
})
export class DisabledDirective {
  readonly ngControl: NgControl = inject(NgControl);
  @Input() set appDisabled(disabled: boolean) {
    console.log('setting new disabled value: ' + disabled, this.ngControl);
    const control: AbstractControl | null = this.ngControl.control;
    if (control) {
      if (disabled) {
        control.disable();
      } else {
        control.enable();
      }
    }
  }
}
